import Http from '../libs/http';
import utils from '../libs/utils';

export default {

  // 获取商品国家放假日期
  getProductHolidays(countryId) {
    return Http.post('/sys/visa_country_holiday_date_query', {
      visa_country_id: countryId,
    });
  },

  // 添加订单
  addOrder(order) {
    return Http.post('/order_add', order);
  },

  // 添加飞猪订单
  addFliggyOrder(order) {
    return Http.post('/ota_order_add', order);
  },

  // 处理最小禁止日期
  handleDisabledDate(earliestTravelDate) {

    const date = new Date(earliestTravelDate);

    // 前一天
    const preDate = new Date(date.getTime() - 86400000);
    // 减完了得到的日期就是禁用日期
    return preDate.format('yyyy-MM-dd');
  },

  // 处理放假和休息数组
  handleHolidayArr(holidays, disabledDate) {
    const newArr = [];

    holidays.forEach((ele) => {
      if (
        new Date(ele).getTime() <= new Date(disabledDate).getTime() &&
        new Date(ele).getTime() >= new Date().getTime() &&
        (new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6)
      ) {
        newArr.push({ date: ele, dayText: '休' });
      } else if (
        new Date(ele).getTime() <= new Date(disabledDate).getTime() &&
        new Date(ele).getTime() >= new Date().getTime() &&
        !(new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6)
      ) {
        newArr.push({ date: ele, dayText: '假' });
      }
    });

    return newArr;
  },

  // 处理使馆放假和休息显示数组
  handleShowHolidayArr(holidays) {
    const newArr = [];

    holidays.forEach((ele) => {
      if (
        new Date(ele).getTime() >= new Date().getTime() &&
        (new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6)
      ) {
        newArr.push({ date: ele, dayText: '休' });
      } else if (
        new Date(ele).getTime() >= new Date().getTime() &&
        !(new Date(ele).getDay() === 0 || new Date(ele).getDay() === 6)
      ) {
        newArr.push({ date: ele, dayText: '假' });
      }
    });
    return newArr;
  },

  // 获取商品支持的身份
  getIdentitys(product, currentFlow) {

    // 邮寄资料可选的身份
    if (currentFlow === 3) {
      return (product.offline && product.offline_material) ? product.offline_material.map(v => v.identity_id) : [];
    }

    // 线上手动添加可选身份
    return product.material ? product.material.map(v => v.identity_id) : [];
  },

  // 获取批量上传资料可选的身份
  getBatchUploadIdentitys(productData) {
    const material = productData.material.filter(el => el.isHavePassportOrIDcard === productData.passportOrIDcard);
    return material ? material.map(v => v.identity_id) : [];
  },

  // 邮寄资料可选的身份
  /* getExpressIdentitys(product) {
    return (product.offline && product.offline_material) ? product.offline_material.map(v => v.identity_id) : [];
  }, */

  // 是否支持线下订单，是否有选择没有配置线下资料的身份
  isOfflineSupportHandler(product, applicants) {
    let isWrongJobSelect = false;
    const isWrongJobSelectArr = [];
    const offline_material = product.offline_material
      ? product.offline_material
      : [];
    const newOrderApplicant = applicants;

    newOrderApplicant.forEach((applicant) => {
      isWrongJobSelectArr.push(
        offline_material.some(
          offline_applicant =>
            applicant.identity_id === offline_applicant.identity_id,
        ),
      );
    });

    isWrongJobSelect = isWrongJobSelectArr.some(
      value => value === false,
    );

    return product.offline === 1 && !isWrongJobSelect;
  },

  // 邮寄资料
  createMaterials(product, applicants, isOta) {
    return product.offline_material.filter((material) => {
      material.names = [];

      let applicantInIndentity = false;

      applicants.forEach((applicant) => {
        if (applicant.identity_id === material.identity_id) {
          if (isOta) {
            material.names.push(applicant.surname + applicant.given_name);
          } else {
            material.names.push(applicant.applicant_name);
          }
          applicantInIndentity = true;
        }
      });

      // 如果申请人id和资料id对应
      if (applicantInIndentity) {
        material.requriedAndElecArr = []; // 必需电子资料
        material.requriedAndPaperArr = []; // 必需纸质资料
        material.optionAndElecArr = []; // 可选电子资料
        material.optionAndPaperArr = []; // 可选纸质资料
        material.applicationArr = []; // 申请表数组
        material.materialAll = [];

        // 若attr=0，则是电子资料存入对应数组，若attr=1，则是纸质资料存入对应数组
        material.material_required.forEach((ma) => {
          if (ma.attr === 0) {
            ma.name = ma.elec_name;
            ma.required = true;
            material.requriedAndElecArr.push(ma);
          } else if (ma.attr === 1) {
            ma.name = ma.paper_name;
            ma.required = true;
            material.requriedAndPaperArr.push(ma);
          }
        });

        material.material_optional.forEach((ma) => {
          if (ma.attr === 0) {
            ma.name = ma.elec_name;
            ma.required = false;
            material.optionAndElecArr.push(ma);
          } else if (ma.attr === 1) {
            ma.name = ma.paper_name;
            ma.required = false;
            material.optionAndPaperArr.push(ma);
          }
        });

        // 将所有数组按序拼接成完成数组
        material.materialAll = [
          ...material.materialAll,
          ...material.requriedAndElecArr,
          ...material.applicationArr,
          ...material.requriedAndPaperArr,
          ...material.optionAndElecArr,
          ...material.optionAndPaperArr,
        ];
      }

      return applicantInIndentity;
    });
  },

  // 获取错误消息
  // 兼容飞猪订单添加申请人
  getErrorMsg(applicant, isFliggy) {
    if (isFliggy) {
      const msgs = [];
      if (!applicant.surname) {
        msgs[1] = '请输入姓(中文)';
      } else if (!/^[\u4e00-\u9fa5]+$/.test(applicant.surname)) {
        msgs[1] = '姓(中文)含有非法字符';
      }
      if (!applicant.given_name) {
        msgs[2] = '请输入名(中文)';
      } else if (!/^[\u4e00-\u9fa5]+$/.test(applicant.given_name)) {
        msgs[2] = '名(中文)含有非法字符';
      }
      if (!applicant.surname_pinyin) {
        msgs[3] = '请输入姓(拼音)';
      } else if (applicant.surname_pinyin.length < 2 && /^[A-Z]+$/.test(applicant.surname_pinyin)) {
        msgs[3] = '姓(拼音)至少为2个英文字母';
      } else if (!/^[A-Z]+$/.test(applicant.surname_pinyin)) {
        msgs[3] = '姓(拼音)仅支持英文大写字母';
      } else if (applicant.surname_pinyin.length < 2 || !/^[A-Z]+$/.test(applicant.surname_pinyin)) {
        msgs[3] = '姓(拼音)由至少2个大写英文字母构成';
      }
      if (!applicant.given_name_pinyin) {
        msgs[4] = '请输入名(拼音)';
      } else if (applicant.given_name_pinyin.length < 2 && /^[A-Z]+$/.test(applicant.given_name_pinyin)) {
        msgs[4] = '名(拼音)至少为2个英文字母';
      } else if (!/^[A-Z]+$/.test(applicant.given_name_pinyin)) {
        msgs[4] = '名(拼音)仅支持英文大写字母';
      } else if (applicant.given_name_pinyin.length < 2 || !/^[A-Z]+$/.test(applicant.given_name_pinyin)) {
        msgs[4] = '名(拼音)由至少2个大写英文字母构成';
      }
      if (!applicant.credential_no) {
        msgs[5] = '请输入护照号';
      } else if (applicant.credential_no.length !== 9 || !/^[A-Z0-9]+$/.test(applicant.credential_no)) {
        msgs[5] = '请输入正确的护照号';
      }
      if (applicant.identity_id === undefined) {
        msgs[6] = '请选择旅客身份';
      }
      for (let i = 0; i < msgs.length; i++) {
        if (msgs[i]) {
          msgs[0] = msgs[i];
          break;
        }
      }
      return msgs;
    }
    // 非飞猪订单
    if (!applicant.applicant_name) {
      return '请填写出行人姓名';
    } else if (applicant.applicant_name.length < 2) {
      return '出行人姓名过短';
    } else if (applicant.identity_id === undefined) {
      return '请选择旅客身份';
    }


    return '';
  },

  // 飞猪申请人在输入框失去焦点时会做校验，与提交时的校验不太一样
  getBlurErrorMsg(field, value) {
    switch (field) {
      case 'surname':
        if (!value) {
          return '请输入姓(中文)';
        } else if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
          return '姓(中文)含有非法字符';
        } break;
      case 'given_name':
        if (!value) {
          return '请输入名(中文)';
        } else if (!/^[\u4e00-\u9fa5]+$/.test(value)) {
          return '名(中文)含有非法字符';
        } break;
      case 'surname_pinyin':
        if (!value) {
          return '请输入姓(拼音)';
        } else if (value.length < 2 && /^[A-Z]+$/.test(value)) {
          return '姓(拼音)至少为2个英文字母';
        } else if (!/^[A-Z]+$/.test(value)) {
          return '姓(拼音)仅支持英文大写字母';
        } break;
      case 'given_name_pinyin':
        if (!value) {
          return '请输入名(拼音)';
        } else if (value.length < 2 && /^[A-Z]+$/.test(value)) {
          return '名(拼音)至少为2个英文字母';
        } else if (!/^[A-Z]+$/.test(value)) {
          return '名(拼音)仅支持英文大写字母';
        } break;
      case 'credential_no':
        if (!value) {
          return '请输入护照号';
        } else if (value.length !== 9 || !/^[A-Z0-9]+$/.test(value)) {
          return '护照号码为9位，仅支持输入字母和数字';
        } break;
      case 'phone':
        if (!value) {
          return '请输入手机号';
        } else if (!/^1\d{10}$/.test(value)) {
          return '手机号为11位数字';
        } break;
      default: return '';
    }
  },

  // 所选的商品配置的资料中是否包含了护照和身份证
  /*
  identity_id | int | 身份id 0 在职人员 1 自由职业者 2 退休人员 3 在校学生 4 学龄前儿童 |
   */
  isHavePassportOrIDcard(product) {

    const productData = utils.deepCopy(product);
    let [passportID, IDcard] = [0, 0]; // 当前批量上传资料（护照或身份证）的 ID

    // 所有的身份
    // const identity = status.identity;

    // 商品对应的资料
    productData.material.forEach((el) => {

      // 该身份对应的所有资料
      const allMaterial = el.material_optional.concat(el.material_required);

      // 从所有资料中找到护照和身份证
      const isHavePassport = allMaterial.find(m => m.pattern && m.pattern === 2);
      const isHaveIDcard = allMaterial.find(m => m.pattern && m.pattern === 1);

      // 优先找护照
      if (isHavePassport) {
        passportID = isHavePassport.elec_id;
        el.isHavePassportOrIDcard = 2;
      } else if (isHaveIDcard) {
      // 没有护照时再看有无身份证

        IDcard = isHaveIDcard.elec_id;
        el.isHavePassportOrIDcard = 1;
      } else {
      // 如果都没有的时候

        el.isHavePassportOrIDcard = 0;
      }
    });

    if (productData.material.find(el => el.isHavePassportOrIDcard === 2)) {
      productData.passportOrIDcard = 2;
      productData.batchUploadElecID = passportID;
    } else if (productData.material.find(el => el.isHavePassportOrIDcard === 1)) {
      productData.passportOrIDcard = 1;
      productData.batchUploadElecID = IDcard;
    } else {
      productData.passportOrIDcard = 0;
    }

    return productData;
  },

  /**
   * 比较两个日期大小
   * @param String a yyyy-mm-dd
   * @param String b yyyy-mm-dd
   * @return Number 1(a>b), 0(a=b), -1(a<b)
   */
  compareDate(a, b) {
    if (a === b) {
      return 0;
    }
    const aTemp = a.split('-').map(item => Number(item));
    const bTemp = b.split('-').map(item => Number(item));
    if (aTemp[0] > bTemp[0]) {
      return 1;
    } else if (aTemp[0] < bTemp[0]) {
      return -1;
    }

    if (aTemp[1] > bTemp[1]) {
      return 1;
    } else if (aTemp[1] < bTemp[1]) {
      return -1;
    }

    if (aTemp[2] > bTemp[2]) {
      return 1;
    }

    return -1;
  },
};



// WEBPACK FOOTER //
// ./src/services/add-new-order-service.js